import { AxiosResponse } from 'axios';

import { useMembersContext } from '@/contexts/membersContext';
import { OnboardingContextState } from '@/contexts/onboardingContext';
import ajax from '@/utils/ajax';

// Referrer handles the backend uses to decide onboarding experiment eligibility
export interface OnboardingReferrerParams {
  httpReferrerUrl: string | null;
  gtm_referrer: string | null;
}

export const onboardingRepository = {
  async get({
    host,
    referrer
  }: {
    host: string;
    referrer?: OnboardingReferrerParams;
  }): Promise<OnboardingContextState> {
    const path = `/api/surveys/onboarding/`;
    const response = await ajax.get({
      url: `${host}${path}`,
      params: { ...referrer },
      config: {
        withCredentials: true
      }
    });

    return response.data;
  },

  async post({
    host,
    data,
    recaptchaToken
  }: {
    host: string;
    data: OnboardingContextState;
    recaptchaToken?: string | null;
  }): Promise<OnboardingContextState> {
    const url = `${host}/api/surveys/onboarding/`;
    const response = await ajax.post<OnboardingContextState, AxiosResponse<OnboardingContextState>>(
      {
        url,
        data,
        headers: recaptchaToken
          ? {
              ...ajax.getHeaders(url),
              'X-Recaptcha-Token': recaptchaToken,
              'X-Recaptcha-Platform': 'web'
            }
          : undefined,
        config: {
          withCredentials: true,
          withXSRFToken: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-CSRFToken'
        }
      }
    );

    return response.data;
  }
};

const OnboardingRepository = () => {
  const { host } = useMembersContext();

  return {
    async get(referrer?: OnboardingReferrerParams): Promise<OnboardingContextState> {
      return onboardingRepository.get({ host, referrer });
    },
    async post(
      data: OnboardingContextState,
      recaptchaToken?: string | null
    ): Promise<OnboardingContextState> {
      return onboardingRepository.post({ host, data, recaptchaToken });
    }
  };
};

export default OnboardingRepository;
